<template>
    <el-container style="height: 100%;">
        <el-aside class="aside-classify-tree">
            <el-header class="extdnd-group-aside-header-class">
                <span style="font-weight:bold">{{ $t('pgCommon.MODEL_LIST') }}</span>
            </el-header>
            <el-main style="height:auto">
                <!-- 加载流程组单列表-->
                <td-single-list
                    ref="tdSingleList"
                    rowKey="deploymentId"
                    :height="listHeight"
                    :hasDefaultSelection="true"
                    :hasPageMemory="true"
                    :lazyloading="true"
                    :columnObj="columnObj"
                    @currentChange="selectionChange"
                    :interfaceName="interfaceName"
                ></td-single-list>
            </el-main>
        </el-aside>
        <el-container style="width:100%">
            <el-header style="height:7%">
                <el-form>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item style="margin-left:5px;">
                                <td-button :type="btType1" :loading="loading" @click="btnQuery">{{ $t('pgCommon.MY_WORK_FLOW') }}</td-button>

                                <td-button :type="btType2" :loading="loading" @click="hisTaskQueryBt">{{ $t('pgCommon.COMPLETED') }}</td-button>

                                <td-button :type="btType3" :loading="loading" @click="applyQueryBt">{{ $t('pgCommon.APPLIED') }}</td-button>

                                <td-button :type="btType4" :loading="loading" @click="invoQueryBt">{{ $t('pgCommon.JOINED') }}</td-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
            <el-main>
                <!-- 加载表格 -->
                <td-table
                    :columns="columns"
                    ref="leaveBill"
                    :dataSource="tableData"
                    :hasMutiSelect="false"
                    :pageSize="pageSize"
                    :currentPage="currentPage"
                    :hasLoading="hasLoading"
                    :total="total"
                    :rowKey="rowKey"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                ></td-table>
                <!-- 加载dialog -->
                <dialog-leaveBill
                    v-if="dialogLeaveBillVisible"
                    :dialogLeaveBillVisible="dialogLeaveBillVisible"
                    :editItem="editItem"
                    :title="title"
                    :sIdDisabled="sIdDisabled"
                    :btnShow="btnShow"
                    :hasReadShow="hasReadShow"
                    :groupElement="groupElement"
                    :tdDynamicObjs="tdDynamicObjList"
                    @dialogLeaveBillClose="dialogLeaveBillClose"
                    @dialogLeaveBillCloseOnly="dialogLeaveBillCloseOnly"
                ></dialog-leaveBill>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import dialogLeaveBill from './components/dealPage.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-leaveBill': dialogLeaveBill
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.initRegex();
    },
    // 定义数据
    data() {
        return {
            passkey: [],
            interfaceName: { query: '/templateManage/queryTemplate', search: '/templateManage/queryTemplate' },
            //单列表对象
            columnObj: {
                id: 'templateKey',
                prop: 'templateName'
            },
            listHeight: window.innerHeight - 245,
            hasLoading: false,
            columns: [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'applyTime',
                    label: this.$t('pgCommon.APPROVAL_TIME'),
                    align: 'center',
                    tableWidth: '200',
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'createTime',
                    label: this.$t('pgCommon.TASK_CREATE_TIME'),
                    align: 'center',
                    tableWidth: '200',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '100',
                    align: 'center',
                    render: (createElement, params) => {
                        if (this.passkey.includes(params.row.templateKey)) {
                            return [];
                        } else {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnEdit(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.CHECK')
                                )
                            ]);
                        }
                    }
                }
            ],
            permissionsView: ['workflow:view'],
            permissionsEdit: ['workflow:edit'],
            permissionsAdd: ['workflow:add'],
            tableData: [],
            groupElement: {},
            btType1: 'primary',
            btType2: 'default',
            btType3: 'default',
            btType4: 'default',
            rowKey: 'taskId',
            hasReadShow: false,
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            editItem: {},
            param: '',
            loading: false, // 按钮是否为加载状态
            dialogLeaveBillVisible: false,
            btnShow: false,
            tdDynamicObjList: [],
            templateKey: '',
            proDefKey: ''
        };
    },
    // 方法的实现
    methods: {
        initRegex() {
            let params = {
                sTag: 'WORKFLOW_PASS_KEY'
            };
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                if (response.data.content.length > 0) {
                    for (let index in response.data.content) {
                        this.passkey.push(response.data.content[index].sCode);
                    }
                }
                this.btnQuery();
            });
        },
        //选择事件
        selectionChange(currentRow) {
            if (currentRow == null) {
                return;
            }
            this.templateKey = currentRow.templateKey;
            this.proDefKey = currentRow.templateKey;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.btType1 = 'primary';
            this.btType2 = 'default';
            this.btType3 = 'default';
            this.btType4 = 'default';
            this.currentPage = 1;
            this.queryList();
        },
        // 查询数据
        hisTaskQueryBt() {
            this.btType1 = 'default';
            this.btType2 = 'primary';
            this.btType3 = 'default';
            this.btType4 = 'default';
            this.currentPage = 1;
            this.hisTaskQuery();
        },
        // 查询数据
        applyQueryBt() {
            this.btType1 = 'default';
            this.btType2 = 'default';
            this.btType3 = 'primary';
            this.btType4 = 'default';
            this.currentPage = 1;
            this.applyQuery();
        },
        // 查询数据
        invoQueryBt() {
            this.btType1 = 'default';
            this.btType2 = 'default';
            this.btType3 = 'default';
            this.btType4 = 'primary';
            this.currentPage = 1;
            this.invoQuery();
        },
        queryByCurrType() {
            if (this.btType1 == 'primary') {
                this.queryList();
            }
            if (this.btType2 == 'primary') {
                this.hisTaskQuery();
            }
            if (this.btType3 == 'primary') {
                this.applyQuery();
            }
            if (this.btType4 == 'primary') {
                this.invoQuery();
            }
        },
        queryList() {
            this.hasLoading = true;
            this.columns = [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'applyTime',
                    label: this.$t('pgCommon.APPROVAL_TIME'),
                    align: 'center',
                    tableWidth: '200',
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'createTime',
                    label: this.$t('pgCommon.TASK_CREATE_TIME'),
                    align: 'center',
                    tableWidth: '200',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '100',
                    align: 'center',
                    render: (createElement, params) => {
                        if (this.passkey.includes(params.row.templateKey)) {
                            return [];
                        } else {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnEdit(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.CHECK')
                                )
                            ]);
                        }
                    }
                }
            ];
            let roleIdStr = sessionStorage.getItem('structureId');
            let param = {
                templateKey: this.templateKey,
                userId: sessionStorage.getItem('userId'),
                roleIds: roleIdStr == undefined || roleIdStr == '' || roleIdStr == null ? roleIdStr : roleIdStr.split(','),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true
            };
            Api.findTask(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.hasLoading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.hasLoading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.hasLoading = false;
                this.loading = false;
            });
        },
        // 已办理
        hisTaskQuery() {
            this.hasLoading = true;
            this.btType1 = 'default';
            this.btType2 = 'primary';
            this.btType3 = 'default';
            this.btType4 = 'default';
            this.columns = [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'applyTime',
                    label: this.$t('pgCommon.APPROVAL_TIME'),
                    align: 'center',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        if (this.passkey.includes(params.row.templateKey)) {
                            return [];
                        } else {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.showBtn(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.CHECK')
                                )
                            ]);
                        }
                    }
                }
            ];
            let param = {
                templateKey: this.templateKey,
                userId: sessionStorage.getItem('userId'),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true,
                isFinished: true,
                systemId: sessionStorage.systemId
            };
            Api.findHisTask(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.hasLoading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.hasLoading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.hasLoading = false;
                this.loading = false;
            });
        },
        // 已发起
        applyQuery() {
            this.hasLoading = true;
            this.btType1 = 'default';
            this.btType2 = 'default';
            this.btType3 = 'primary';
            this.btType4 = 'default';
            this.columns = [
                {
                    prop: 'proInsId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'proDefKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'currTaskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'currTaskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        if (this.passkey.includes(params.row.proDefKey)) {
                            return [];
                        } else {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnShowApply(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.CHECK')
                                )
                            ]);
                        }
                    }
                }
            ];
            let param = {
                proDefKey: this.proDefKey,
                applyUserId: sessionStorage.getItem('userId'),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true
            };
            Api.findHisProcess(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.hasLoading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.hasLoading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.hasLoading = false;
                this.loading = false;
            });
        },
        // 已参与
        invoQuery() {
            this.hasLoading = true;
            this.btType1 = 'default';
            this.btType2 = 'default';
            this.btType3 = 'default';
            this.btType4 = 'primary';
            this.columns = [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'applyTime',
                    label: this.$t('pgCommon.APPROVAL_TIME'),
                    align: 'center',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        if (this.passkey.includes(params.row.templateKey)) {
                            return [];
                        } else {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.showBtn(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.CHECK')
                                )
                            ]);
                        }
                    }
                }
            ];
            let param = {
                templateKey: this.templateKey,
                involvedUserId: sessionStorage.getItem('userId'),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true,
                systemId: sessionStorage.systemId
            };
            // 自定义封装前台输出日志方法
            // this.$log.info(param);
            Api.findHisTask(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.hasLoading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.hasLoading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.hasLoading = false;
                this.loading = false;
            });
        },
        // 我的流程
        btnEdit(row) {
            this.hasReadShow = false;
            this.btnShow = false;
            let params = {
                tableName: 'PROCESS_' + row.templateKey,
                sid: row.processId
            };
            Api.selfBuildTableSelect(JSON.stringify(params), response => {
                if (undefined != response.data.content[0]) {
                    this.groupElement = response.data.content[0];
                }
                this.groupElement.currPerson = sessionStorage.getItem('username');
                this.editItem = row;
                this.title = this.$t('pgCommon.WAIT_DEAL');
                // this.isAddData = false;
                this.dialogLeaveBillVisible = true;
                this.sIdDisabled = false;
                this.btnShow = true;
                if (row.taskParentId != '' && row.taskParentId != null) {
                    this.hasReadShow = true;
                    this.btnShow = false;
                }
            });
        },
        // 已办理、已参与
        showBtn(row) {
            let params = {
                tableName: 'PROCESS_' + row.templateKey,
                sid: row.processId
            };
            Api.selfBuildTableSelect(JSON.stringify(params), response => {
                if (undefined != response.data.content[0]) {
                    this.groupElement = response.data.content[0];
                }
                this.groupElement.currPerson = sessionStorage.getItem('username');
                let keys = Object.keys(this.groupElement);
                for (let key in keys) {
                    let obj = {
                        keyName: keys[key],
                        operateType: 0,
                        propsObjList: [
                            //自定义属性
                            {
                                propsName: 'disabled',
                                propsValue: true
                            }
                        ]
                    };
                    this.tdDynamicObjList.push(obj);
                }
                let nextU = {
                    keyName: 'nextUsers_handle',
                    operateType: 0,
                    styleObj: { display: 'none' } //自定义样式
                };
                let nextG = {
                    keyName: 'nextGroups_handle',
                    operateType: 0,
                    styleObj: { display: 'none' }
                };
                let nextS = {
                    keyName: 'showUsers_handle',
                    operateType: 0,
                    styleObj: { display: 'none' }
                };
                let taskComments = {
                    keyName: 'taskComments',
                    operateType: 0,
                    propsObjList: [
                        {
                            propsName: 'disabled',
                            propsValue: true
                        }
                    ]
                };
                this.tdDynamicObjList.push(nextU);
                this.tdDynamicObjList.push(nextG);
                this.tdDynamicObjList.push(nextS);
                this.tdDynamicObjList.push(taskComments);
                this.title = this.$t('pgCommon.CHECK');
                this.sIdDisabled = true;
                this.btnShow = false;
                this.hasReadShow = false;
                this.editItem = row;
                this.dialogLeaveBillVisible = true;
            });
        },
        // 已发起
        btnShowApply(row) {
            let params = {
                tableName: 'PROCESS_' + row.proDefKey,
                sid: row.proInsId
            };
            Api.selfBuildTableSelect(JSON.stringify(params), response => {
                if (undefined != response.data.content[0]) {
                    this.groupElement = response.data.content[0];
                }
                this.groupElement.currPerson = sessionStorage.getItem('username');
                let keys = Object.keys(this.groupElement);
                for (let key in keys) {
                    let obj = {
                        keyName: keys[key],
                        operateType: 0,
                        propsObjList: [
                            {
                                propsName: 'disabled',
                                propsValue: true
                            }
                        ]
                    };
                    this.tdDynamicObjList.push(obj);
                }
                let nextU = {
                    keyName: 'nextUsers_handle',
                    operateType: 0,
                    styleObj: { display: 'none' }
                };
                let nextG = {
                    keyName: 'nextGroups_handle',
                    operateType: 0,
                    styleObj: { display: 'none' }
                };
                let nextS = {
                    keyName: 'showUsers_handle',
                    operateType: 0,
                    styleObj: { display: 'none' }
                };
                let taskComments = {
                    keyName: 'taskComments',
                    operateType: 0,
                    propsObjList: [
                        {
                            propsName: 'disabled',
                            propsValue: true
                        }
                    ]
                };
                this.tdDynamicObjList.push(nextU);
                this.tdDynamicObjList.push(nextG);
                this.tdDynamicObjList.push(nextS);
                this.tdDynamicObjList.push(taskComments);
                row.processId = row.proInsId;
                this.title = this.$t('pgCommon.CHECK');
                this.sIdDisabled = true;
                this.btnShow = false;
                this.hasReadShow = false;
                row.templateKey = row.proDefKey;
                row.processId = row.proInsId;
                if (row.currTaskKey == 'finished') {
                    row.taskKey = row.endShowKey;
                } else {
                    row.taskKey = row.currTaskKey;
                }
                this.editItem = row;
                this.dialogLeaveBillVisible = true;
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryByCurrType();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryByCurrType();
        },
        // 关闭页面
        dialogLeaveBillClose() {
            this.dialogLeaveBillVisible = false;
            // this.btnQuery();
        },
        dialogLeaveBillCloseOnly() {
            this.dialogLeaveBillVisible = false;
            this.btnQuery();
        }
    }
};
</script>
